import { Flex, useMediaQuery } from "@chakra-ui/react"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { InboxPopover } from "./InboxSelector"
import useInboxItems, { InboxGroupNode } from "./useInboxItems"

const InboxNavigatorIndicator = ({
  onSelect
}: {
  onSelect?: (item: InboxGroupNode) => void
}) => {
  const { me } = usePathwrightContext()
  const { items, loading } = useInboxItems()

  // Attempt to assess if user has necessary roles to access inbox.
  // User must be moderator or teacher of Cohort or mentor of Community Group.
  const hasNecessaryRoles = me?.group_role_stats?.some(
    (group) =>
      ((group?.type === "active_registration" ||
        group?.type === "registration") &&
        !!group?.role &&
        (group.role == 10 || group.role == 15)) ||
      (group?.type === "community_group" && !!group?.role && group.role === 10)
  )

  // The 420px comes from the width set on the PopoverContent in InboxSelector.
  // When there's room for the full width of the popover, with alight to bottom-end,
  // otherwise align to bottom which should center the popover.
  // Note: there's currently some offset on the popover transform that basically
  // results in shifting the negative space to the opposite side, so we're not gaining
  // anything ATM here.
  const placement = useMediaQuery("(min-width: 420px)")[0]
    ? "bottom-end"
    : "bottom"

  // Correct to only show InboxNavigatorIndicator when there are items?
  // TODO: Othwerwise we need a blank slate.
  if (!hasNecessaryRoles && (loading || !items.length)) return null
  if (!me) return null

  return (
    <Flex display="flex" alignItems="center" m="0 10px">
      <InboxPopover onSelect={onSelect} placement={placement}>
        {({ isOpen }) => (
          <IconButton
            icon="inbox"
            inverted
            styleType={isOpen ? "primary" : "tertiary"}
            rounded={false}
            // Likely unhelpful to show indicator simpley because the user has
            // staff access to cohorts or mentor groups. This will be helpful in the
            // future when each user has their own review objects.
            // indicator={!!count}
          />
        )}
      </InboxPopover>
    </Flex>
  )
}

InboxNavigatorIndicator.displayName = "InboxNavigatorIndicator"

export default InboxNavigatorIndicator
